import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { PRESENT_DEVICE_USER_ACTIONS, PresentDeviceUserActions } from '@/app/platform/platform-data/actions/types';
import { PRESENT_DEVICE_USER_QUERIES, PresentDeviceUserQueries } from '@/app/platform/platform-data/queries/types';
import { CONFIRMER, Confirmer } from '@shared/components/dialogs/confirm/types';

@Component({
    selector: 'present-users-live-dashboard-view',
    templateUrl: './present-users-live-dashboard-view.component.html',
    styleUrls: ['./present-users-live-dashboard-view.component.scss'],
    host: {},
    standalone: false
})
export class PresentUsersLiveDashboardViewComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(PRESENT_DEVICE_USER_ACTIONS)
    private readonly presentDeviceUserActions: PresentDeviceUserActions,
    @Inject(PRESENT_DEVICE_USER_QUERIES)
    readonly presentDeviceUserQueries: PresentDeviceUserQueries,
    @Inject(CONFIRMER)
    private readonly confirmer: Confirmer
  ) {}

  async ngOnInit() {
    await this.presentDeviceUserActions.startListening();
  }

  async ngOnDestroy() {
    await this.presentDeviceUserActions.stopListening();
  }

  async onForceInvalidateAll() {
    const confirmation = await this.confirmer.confirm(
      'Ben je zeker dat je alle gebruikers wil afmelden?',
      { color: 'danger' }
    );

    if (!confirmation) {
      return;
    }

    await this.presentDeviceUserActions.forceInvalidateAll();
  }

  async onForceStopAll() {
    const confirmation = await this.confirmer.confirm(
      'Ben je zeker dat je alle gebruikers wil afmelden?',
      { color: 'danger' }
    );

    if (!confirmation) {
      return;
    }

    await this.presentDeviceUserActions.forceStopAll();
  }
}
